import { DeleteInitiativeNotifications } from './notifications';
import { InitiativeDetailIndex } from './detail/Index';
import { InitiativesSummaryIndex } from './summary/Index';
import { PARAMS } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
export const InitiativesIndex = () => {
    const location = useLocation();
    return (React.createElement(React.Fragment, null,
        React.createElement(Routes, null,
            React.createElement(Route, { element: React.createElement(InitiativesSummaryIndex, null), path: '' }),
            React.createElement(Route, { element: React.createElement(InitiativeDetailIndex, { key: location.pathname }), path: PARAMS.ID })),
        React.createElement(DeleteInitiativeNotifications, null)));
};
